import {Request} from 'express';
import {IncomingMessage} from 'http';
import {
  HEADER_X_FORWARDED_FOR,
  HEADER_X_ORIGINAL_FORWARDED_FOR,
} from './constants';

/**
 * k8s 에서 x-forwarded-for 에 클라이언트 IP 가 전달되는게 아니라 프록시 된 IP 만 전달되고 있네요;; 헤더를 까보니 X-Original-Forwarded-For 에 클라이언트 IP 가 전달되는것으로 확인되어 이 값을 우선하도록 합니다.
 * 즉, 다음 우선순위로 클라이언트 IP 를 판단합니다
 * 1. X-Original-Forwarded-For
 * 2. X-Forwarded-For
 * 3. 현재 요청의 ip 주소
 */
export function getClientIp(req?: Request | IncomingMessage): string {
  const defaultIp = req?.socket?.remoteAddress || process.env.IP;

  const result =
    req && 'get' in req && typeof req?.get === 'function'
      ? req.get(HEADER_X_ORIGINAL_FORWARDED_FOR) &&
        req.get(HEADER_X_ORIGINAL_FORWARDED_FOR) !== 'undefined' // 희안하게 undefined string 으로 들어옴;
        ? req.get(HEADER_X_ORIGINAL_FORWARDED_FOR)
        : req.get(HEADER_X_FORWARDED_FOR)
          ? req.get(HEADER_X_FORWARDED_FOR)
          : defaultIp
      : defaultIp; //  msw

  return result || 'unknown';
}
